import { Icons } from "assets";
import classNames from "classnames";
import { useCallback, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { Document, Page, pdfjs } from "react-pdf";
import CustomButton from "shared/components/common/customButton";
import { toastMessage } from "shared/components/common/toast";
import { UploadFile } from "shared/services/general";
import { checkFileIsPdf } from "shared/utils/helper";
import styles from "./style.module.scss";
import SuccessModal from "shared/modal/success";

const DocumentPage = () => {
  const [file, setFile] = useState<File>();
  const [loading, setLoading] = useState<boolean>(false);
  const [time, setTime] = useState<any>(new Date().getTime());
  const [showSuccessModal, setShowSuccessModal] = useState<boolean>(false);

  const handleShowSuccessModal = () => {
    setShowSuccessModal(true);
  };

  const handleCloaseSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const onDrop = useCallback((acceptedFiles: any) => {
    let getFile: any = acceptedFiles[0];
    if (getFile) {
      const fileSizeInBytes = getFile.size;
      const fileSizeInKilobytes = fileSizeInBytes / 1024;
      const fileSizeInMegabytes = fileSizeInKilobytes / 1024;
      if (Number(fileSizeInMegabytes) < 20) {
        if (checkFileIsPdf(getFile.type)) {
          setFile(getFile);
        } else {
          toastMessage("error", "Only pdf are supported");
        }
      } else {
        toastMessage("error", "File is too large");
      }
    }
    // eslint-disable-next-line
  }, []);

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  const handleUpload = () => {
    if (file) {
      setLoading(true);
      const formData = new FormData();
      formData.append("file", file as Blob);
      UploadFile(formData)
        .then(({ data, status }) => {
          if (status) {
            handleShowSuccessModal();
            setTime(new Date().getTime());
            setFile(undefined);
          }
        })
        .catch((err) => {
          toastMessage("error", err?.response?.data?.message);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      toastMessage("error", "Please select a file to upload");
    }
  };

  useEffect(() => {
    setTime(new Date().getTime());
    pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
  }, []);

  return (
    <section
      className={classNames(
        "relative h-full flex flex-col justify-between gap-4"
      )}
    >
      <div className={classNames(styles.mainContainer, "gap-10")}>
        <div className={classNames("flex flex-col gap-6")}>
          <h1>Current File</h1>
          <Document
            file={`https://dev-cors-proxy.upworkdeveloper.com/https://rastrack-api.compgovpartners.com/usermanual/usermanual.pdf?timestamp=${time}`}
            className={classNames(styles.pdfContainer, "cursor-pointer")}
            onClick={() => {
              window.open(
                "https://rastrack-api.compgovpartners.com/usermanual/usermanual.pdf",
                "_blank"
              );
            }}
          >
            <Page pageNumber={1} />
          </Document>
        </div>

        <div className={classNames("flex flex-col gap-6")}>
          <h1>Upload New Guide</h1>

          <div>
            <input
              id="upload-file"
              name="upload-file"
              type="file"
              className="hidden"
              {...getInputProps()}
              accept="application/pdf"
            />

            <label
              htmlFor="upload-file"
              className={classNames(
                styles.uploadContainer,
                "gap-3 cursor-pointer"
              )}
              {...getRootProps({
                onClick: (e: any) => e.stopPropagation(),
              })}
            >
              {file ? (
                <>
                  <Icons.File />
                  <h5>{file?.name}</h5>
                </>
              ) : (
                <>
                  <Icons.UplaodFile />
                  <div
                    className={classNames("flex flex-col gap-2 items-center")}
                  >
                    <h5>Drag or drop files here.</h5>
                    <p>Max 50 MB</p>
                  </div>
                </>
              )}
            </label>
          </div>

          <CustomButton
            title="Upload Guide"
            containerStyle={"ms-auto"}
            loading={loading}
            disabled={loading}
            onClick={handleUpload}
          />
        </div>
      </div>
      <SuccessModal
        title="Successful Submission"
        subtitle="Your Guide has been Uploaded successfully"
        actionButtonText="Ok"
        show={showSuccessModal}
        handleClose={handleCloaseSuccessModal}
      />
    </section>
  );
};

export default DocumentPage;
